import { render } from "./Interface.vue?vue&type=template&id=3c7ca20e&scoped=true"
import script from "./Interface.vue?vue&type=script&lang=js"
export * from "./Interface.vue?vue&type=script&lang=js"

import "./Interface.vue?vue&type=style&index=0&id=3c7ca20e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7ca20e"]])

export default __exports__